export default __webpack_public_path__ + "static/media/siriusxm.0cede875.svg";